const digest = '1626c907767f6330325fb3026a9fc263c9f40b4faa075126359face6f68c9e03';
const css = `._descriptionText_ri19p_1 small{display:block;margin-top:8px}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'descriptionText': '_descriptionText_ri19p_1' };
export const descriptionText = '_descriptionText_ri19p_1';
export { css, digest };